export default __webpack_public_path__ + "static/media/bnr4.f2c0c13f.jpg";